import { useQueryClient } from "react-query";

import { IAuthenticationResponse } from "types/authenticationResponse";

export function useRefreshAccessToken(): () => Promise<IAuthenticationResponse> {
  const queryClient = useQueryClient();

  return async () => queryClient.fetchQuery("/auth/refreshAccessToken");
}
